import { useRef, useState } from 'react';

interface FileUploadProps {
  file: File | null;
  onFileSelect: (file: File) => void;
  onFileRemove: () => void;
  disabled: boolean;
}

export default function FileUpload({ file, onFileSelect, onFileRemove, disabled }: FileUploadProps) {
  const [dragging, setDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    if (!disabled) {
      setDragging(true);
    }
  };

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragging(false);

    if (disabled) return;

    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && isValidFile(droppedFile)) {
      onFileSelect(droppedFile);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile && isValidFile(selectedFile)) {
      onFileSelect(selectedFile);
    }
  };

  const isValidFile = (file: File): boolean => {
    const validExtensions = ['.xlsx', '.xls', '.csv'];
    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    return validExtensions.includes(fileExtension);
  };

  const handleClick = () => {
    if (!disabled) {
      fileInputRef.current?.click();
    }
  };

  return (
    <div className="upload-section">
      {!file ? (
        <div
          className={`upload-area ${dragging ? 'dragging' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleClick}
        >
          <h3>📁 Upload Excel File</h3>
          <p>Drag and drop your Excel file here, or click to browse</p>
          <p style={{ fontSize: '0.9rem', color: '#999' }}>
            Supported formats: .xlsx, .xls, .csv
          </p>
          <input
            ref={fileInputRef}
            type="file"
            className="file-input"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            disabled={disabled}
          />
          <button className="upload-btn" disabled={disabled}>
            Choose File
          </button>
        </div>
      ) : (
        <div className="selected-file">
          <span>📄 {file.name}</span>
          <button className="remove-btn" onClick={onFileRemove} disabled={disabled}>
            Remove
          </button>
        </div>
      )}
    </div>
  );
}


